// extracted by mini-css-extract-plugin
export default {"grid":"PartnerDashboardPage_grid__L8PRI","serviceBlock":"PartnerDashboardPage_serviceBlock__uNMVS","serviceList":"PartnerDashboardPage_serviceList__A+Uod"};